import { useCallback } from 'react';

import useRequestJSON from './hooks/useRequestJSON';
import { PostJSON, BaseResponse } from './request';
import { AppKey } from './apps';

interface InvalidationConfig {
  [model: string]: {
    keys: [string];
    keyDisplays: Record<string, string>;
  };
}

interface InvalidationResponse {
  config: InvalidationConfig;
}

interface upper {
  newValue: number;
}

interface lower {
  newValue: number;
}

export interface Invalidation {
  upper?: upper;
  lower?: lower;
  app: string;
  sessionModel: string;
  sessionId: number;
  key: string;
  value: string;
  newValue: string;
  note: string;
  isVoided: boolean;
  voidedAt: Date;
  createdAt: Date;
  updatedAt?: Date;
  deletedAt?: Date;
  patientId: number;
  accountId: number;
  createdById: number;
  previousValue: number | string;
}

export const useGetInvalidationConfig = (
  appKey: AppKey
): InvalidationResponse => {
  const request = useCallback(
    () =>
      PostJSON({
        url: '/data/data_invalidate_config/',
        params: {
          app: appKey
        }
      }),
    [appKey]
  );
  const { data } = useRequestJSON<InvalidationResponse & BaseResponse>({
    request,
    enabled: appKey != null
  });
  return {
    config: data?.config
  };
};
